/**
 * 共享内容选择弹窗
 */
import ShareModal from './share-modal'

export default ShareModal
